import * as d3 from 'd3';
import tooltip from 'd3-tip';
// import _ from 'lodash';
import {
  GetChartData,
  getNoDataFoundLabel,
  renderDrillDownChartOnField
} from '../../../utils/graph_service';
import { getTipInfo } from '../../../utils/helper';
import * as LocalCacheActionType from '../../../store/localCache/actionTypes';
import { groupBarChartUtility } from './groupBarChartUtility';
import store from '../../../store/appStore';
function arcChartUtility (
  chartConfig,
  isDonut,
  divId,
  onDrillDown,
  drillDownConfig,
  level,
  allowDrillDown
) {
  RenderChart();

  // const pie = d3.pie().padAngle(padAngle);

  function RenderChart () {
    // console.log("here", drillDownConfig.isDrillDown, drillDownConfig.key);
    if (drillDownConfig.isDrillDown && allowDrillDown === true) {
      const dirllDownColumnsConfig = { ...chartConfig.configuration };
      if (chartConfig.configuration.drillDownConfig) {
        renderDrillDownChartOnField(chartConfig, drillDownConfig, level, divId, onDrillDown, allowDrillDown);
      } else {
        const filters = [];
        if (chartConfig.configuration.isRepeated === true) {
          filters.push({
            key: chartConfig.configuration.autoGenerate.key,
            values: [
              drillDownConfig.config.find((x) => x.level === level + 1).key
            ]
          });
          dirllDownColumnsConfig.autoGenerate.filters = filters;
        } else {
          dirllDownColumnsConfig.columns = [
            chartConfig.configuration.columns.find(
              (x) =>
                x.name ===
                [drillDownConfig.config.find((x) => x.level === level + 1).key]
            )
          ];
        }
        const resData = GetChartData(
          chartConfig.rawData,
          dirllDownColumnsConfig,
          chartConfig.startDate,
          chartConfig.endDate,
          drillDownConfig.type
        );
        if (drillDownConfig.currentLevel === level + 1) {
          drillDownConfig.isDrillDown = false;
        }
        // console.log("here resData", resData);
        // console.log("here dirllDownColumnsConfig", dirllDownColumnsConfig);
        const config = {
          startDate: chartConfig.startDate,
          endDate: chartConfig.endDate,
          configuration: dirllDownColumnsConfig,
          rawData: chartConfig.rawData,
          data: resData.data,
          yAxisLabel: 'count',
          type: 'GroupBarChart',
          keys: resData.barKeys,
          colors: resData.barColors,
          accessor: resData.chartAccessor.mainAccessor
        };
        groupBarChartUtility(
          config,
          divId,
          onDrillDown,
          drillDownConfig,
          level + 1,
          allowDrillDown
        );
      }
    } else {
      store.dispatch({
        type: LocalCacheActionType.SET_CACHE_DATA,
        payload: { key: chartConfig.widgetId, data: chartConfig?.data }
      });
      store.dispatch({
        type: LocalCacheActionType.SET_CACHE_DATA,
        payload: { key: chartConfig.widgetId + 'drillconfig', data: chartConfig }
      });
      return generateArcChart(
        chartConfig.data,
        chartConfig.colors,
        isDonut,
        divId
      );
    }
  }

  function numberWithCommas (num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // const getAngle = function (d) {
  //   return (180 / Math.PI * (d.startAngle + d.endAngle) / 2 - 90);
  // };

  function generateArcChart (data, colors, isDonut, divId) {
    if (!data) return;
    let width = 300;
    let height = 200;
    const node = document.getElementById(divId);
    let viewHeight = 200;
    const fontsize = '0.786';
    const windowWidth = node.offsetWidth;
    if (windowWidth > width) {
      width = windowWidth - 40;
      height = windowWidth / 2 > height ? windowWidth / 2 + 40 : height;
      viewHeight = node.offsetParent.clientHeight - 40;
    }

    // const windowHeight = node.offsetHeight;
    // if (windowHeight > height) {
    //   height = height + (windowHeight - height);
    //   // height = windowWidth / 2 > height ? windowWidth / 2 : height;
    // }

    let totalCount = 0;
    (data || []).forEach(function (d) {
      totalCount += Math.round(parseFloat(d.attributeValue));
      if (d.percentage < 10 && d.attributeValue > 0) {
        d.percentage += 5;
        (data || []).forEach(function (x, i) {
          if (x.percentage > 50 && i < 5) {
            x.percentage += -1;
          }
        });
      }
      return d;
    });
    if (totalCount <= 0 && drillDownConfig.currentLevel <= 1) {
      node.innerHTML = 'No data available for ' + chartConfig.startDate + ' to ' + chartConfig.endDate;
      node.classList.add('no-data');
      return;
    }

    // const margin = 45;
    let radius = Math.min(width, height) / 2 - 10;

    document.querySelectorAll('.tooltip' + divId).forEach(function (a) {
      a.remove();
    });
    if (node !== null) {
      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }
    }

    const svgContainer = d3
      .select(node)
      .append('svg')
      .attr('width', width)
      .attr('height', viewHeight)
      .attr('viewBox', [
        10,
        10,
        width,
        viewHeight + 80
      ])
      .attr('preserveAspectRatio', 'xMinYMin');
    const svg = svgContainer.append('g')
      .attr('transform', 'translate(' + ((height / 2) + 20) + ', ' + ((height / 2) + 30) + ')');

    totalCount = 0;
    data.forEach(function (d) {
      totalCount += Math.round(parseFloat(d.attributeValue));
      return d;
    });
    if (totalCount <= 0) {
      getNoDataFoundLabel(
        chartConfig.startDate + ' to ' + chartConfig.endDate,
        svg,
        0,
        120
      );
      return;
    }
    const color = d3.scaleOrdinal(colors);
    const pie = d3
      .pie()
      .padAngle(isDonut ? 0.02 : 0)
      .value((d) => parseFloat(d.percentage).toFixed(2))
      .sort(null);

    let innerRadius = 0;
    let outterRadius = 0;
    if (isDonut === true) {
      innerRadius = radius * 0.3;
      outterRadius = radius * 0.7;
    } else {
      outterRadius = radius * 0.7;
      radius = radius - 10;
      innerRadius = 0.1;
    }
    const arc = d3
      .arc()
      .innerRadius(innerRadius)
      .outerRadius(outterRadius);

    const tip = tooltip()
      .attr('class', 'd3-tip tooltip' + divId)
      .html(function (d) {
        // return (
        //   d.data.attributeName +
        //   ' count ' +
        //   numberWithCommas(d.data.attributeValue)
        // );
        return d.data.attributeName + '<br/> <span class="tipspan">' + (chartConfig.configuration?.yAxisLabel ?? 'Count') + ': ' + numberWithCommas(d.data.attributeValue).toString() + '</span><br/>' + getTipInfo(d.data, chartConfig.configuration?.yAxisLabel !== 'Employee Count', chartConfig);
      });
    svg.call(tip);

    // const getAngle = function (d) {
    //   return (180 / Math.PI * (d.startAngle + d.endAngle) / 2 - 90);
    // };

    totalCount = 0;
    data.forEach(function (d) {
      totalCount += Math.round(parseFloat(d.attributeValue));
      return d;
    });

    if (totalCount <= 0) {
      getNoDataFoundLabel(
        chartConfig.startDate + ' to ' + chartConfig.endDate,
        svg,
        0,
        180
      );
    } else {
      svg
        .selectAll('path')
        .data(pie(data))
        .enter()
        .append('path')
        .attr('d', arc)
        .attr('fill', (d, i) => color(i))
        .style('cursor', 'pointer')
        .attr('class', 'arc-container-path' + divId)
        .style('stroke-width', '2.5px').style('stroke', 'white')
        // .on("mouseover", tip.show)
        .on('mouseover', function (d) {
          tip.show(this);
          d3.selectAll('.arc-container-path' + divId)
            .transition()
            .duration(200)
            .style('opacity', 0.5)
            .style('stroke-width', '3px');

          d3.selectAll('.legend' + divId)
            .transition()
            .duration(200)
            .style('opacity', 0.5);

          d3.selectAll('.' + d.data.attributeName?.replace(/[^a-zA-Z0-9]/g, ''))
            .transition()
            .duration(200)
            .style('opacity', 1)
            // .style('font-size', fontsize)
            .style('stroke-width', '1px');

          d3.select(this)
            .transition()
            .duration(200)
            .style('opacity', 1)
            .style('stroke-width', '1px');
        })
        .on('mouseout', function () {
          // svg.select(".title-text").remove();
          tip.hide();
          d3.selectAll('.legend' + divId)
            .transition()
            .duration(200)
            .style('opacity', 1)
            // .style('font-size', fontsize)
            .style('stroke-width', '2.5px');
          d3.selectAll('.arc-container-path')
            .transition()
            .duration(200)
            .style('opacity', 1)
            .style('stroke-width', '2.5px').style('stroke', 'white');
        })
        .on('click', function (d) {
          tip.hide();
          onDrillDown(
            true,
            d.data.attributeName,
            chartConfig.accessor,
            '',
            level + 1,
            d.seriesItem,
            (d.data || {}).data,
            (d.data || {}).keyTitle,
            (d.data || {}).drillDownKey
          );
        });

      svg.append('g').classed('percentage', true);

      // Add the polylines between chart and labels:
      const data_ready = pie(data);

      // Another arc that won't be drawn. Just for labels positioning
      const outerArc = d3.arc()
        .innerRadius(radius * 0.9)
        .outerRadius(radius * 0.9);

      svg
        .selectAll('allPolylines')
        .data(data_ready)
        .enter()
        .append('polyline')
        .attr('stroke', function (d, i) { console.log('arc', d.data.attributeValue); return d.data.attributeValue > 0 ? color(i) : '#00000000'; })
        .style('fill', 'none')
        .attr('stroke-width', function (d, i) { console.log('arc', d.data.attributeValue); return d.data.attributeValue > 0 ? 1 : 0; })
        .attr('points', function (d) {
          const posA = arc.centroid(d); // line insertion in the slice
          const posB = outerArc.centroid(d); // line break: we use the other arc generator that has been built only for that
          const posC = outerArc.centroid(d); // Label position = almost the same as posB
          const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2; // we need the angle to see if the X position will be at the extreme right or extreme left
          posC[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
          return [posA, posB, posC];
        });

      // Add the polylines between chart and labels:
      svg
        .selectAll('allLabels')
        .data(data_ready)
        .enter()
        .append('text')
        .style('color', (d, i) => { console.log('arcvalue', d.data.attributeValue); return d.data.attributeValue > 0 ? color(i) : '#00000000'; })
        .text(function (d) { console.log('arcvalue', d.data.attributeValue); return d.data.attributeValue > 0 ? numberWithCommas(d.data.attributeValue) : ''; })
        .attr('transform', function (d) {
          const pos = outerArc.centroid(d);
          const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
          pos[0] = radius * 0.99 * (midangle < Math.PI ? 1 : -1);
          if (pos[1] === -107.29591400012343) {
            pos[1] = -101.295914;
          }
          if (pos[1] === -94.34640713803958) {
            pos[1] = -87.346407;
          }
          // pos[1] = pos[1] + 7;
          return 'translate(' + pos + ')';
          // return 'translate(' + pos + ') ' +
          //           'rotate(' + getAngle(d) + ')';
        })
        .style('text-anchor', function (d) {
          const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
          return (midangle < Math.PI ? 'start' : 'end');
        });
    }

    const legend = svgContainer.append('g')
      .attr('transform', 'translate(' + ((height / 2) + 50) + ', ' + ((height / 2) + 20) + ')')
      .selectAll('.legend') // selecting elements with class 'legend'
      .data(color.domain()) // refers to an array of labels from our dataset
      .enter() // creates placeholder
      .append('g') // replace placeholders with g elements
      .attr('class', 'legend') // each g is given a legend class
      .attr('transform', function (d, i) {
        const height = 10 + 10; // height of element is the height of the colored square plus the spacing
        const offset = height * color.domain().length / 2; // vertical offset of the entire legend = height of a single element & half the total number of elements
        const horz = radius + 10; // the legend is shifted to the left to make room for the text
        const vert = i * height - offset; // the top of the element is shifted up or down from the center using the offset defiend earlier and the index of the current element 'i'
        return 'translate(' + horz + ',' + vert + ')'; // return translation
      });

    // adding colored squares to legend
    legend.append('rect') // append rectangle squares to legend
      .attr('width', '10px') // width of rect size is defined above
      .attr('height', '10px') // height of rect size is defined above
      .style('fill', color) // each fill is passed a color
      .style('stroke', color); // each stroke is passed a color

    // adding text to legend
    legend.append('text')
      .data(pie(data))
      .attr('x', '15px')
      .attr('y', '10px')
      .attr(
        'class',
        (d, i) => d.attributeName?.replace(/[^a-zA-Z0-9]/g, '') + ' legend' + divId
      )
      .style('fill', (d, i) => color(i))
      .style('font-family', 'roboto')
      .style('font-weight', '500')
      // .style('font-size', fontsize)
      .text(function (d) {
        return (
          d.data.attributeName +
          ' (' +
          (parseInt(totalCount) > 0
            ? numberWithCommas(parseFloat(d.data.attributeValue))
            : 0) +
          ')'
        );
      }).attr('width', 100)
      .style('cursor', 'pointer')
      .on('click', function (d) {
        tip.hide();
        console.log('Onclick', true,
          d.data.attributeName,
          chartConfig.accessor,
          '',
          level + 1,
          d.seriesItem,
          (d.data || {}).data,
          (d.data || {}).keyTitle);
        onDrillDown(
          true,
          d.data.attributeName,
          chartConfig.accessor,
          '',
          level + 1,
          d.seriesItem,
          (d.data || {}).data,
          (d.data || {}).keyTitle,
          (d.data || {}).drillDownKey
        );
      }); // return label

    // const svgSize = svg.node().getBBox();
    // let legendline = svgSize.height / 2 + 10;
    // let currentX = -width / 2 + 20;
    // const legend = svgContainer
    //   .append('g')
    //   .attr('class', 'legend-container')
    //   .attr('x', -width / 2 + 20)
    //   //   .attr("y", height/2)
    //   .attr('width', width - 80);
    // //   .attr(
    // //     "transform",
    // //     "translate(" + -0 + ", " + (width - (margin * 2 + 20)) + ")"
    // //   );
    // legend
    //   .selectAll('g')
    //   .data(data)
    //   .enter()
    //   .append('g')
    //   .each(function (d, i) {
    //     const g = d3.select(this);
    //     let y = legendline;
    //     const rect = g
    //       .append('rect')
    //       .attr('y', y)
    //       .attr('x', currentX)
    //       .attr('width', 10)
    //       .attr('height', 10)
    //       .attr(
    //         'class',
    //         d.attributeName.replace(/[^a-zA-Z0-9]/g, '') + ' legend' + divId
    //       )
    //       .style('fill', colors[i]);
    //     const size = rect.node().getBBox();
    //     currentX += size.width + 10;
    //     if (currentX > width / 2) {
    //       currentX = -width / 2 + 20;
    //       legendline += 20;
    //       y = legendline;
    //       rect.attr('x', currentX).attr('y', y);
    //       currentX += size.width + 10;
    //     }
    //     const recText = g
    //       .append('text')
    //       .attr('y', y + 10)
    //       .attr('x', currentX)
    //       .attr('height', 20)
    //       .attr('width', 170)
    //       .attr(
    //         'class',
    //         d.attributeName.replace(/[^a-zA-Z0-9]/g, '') + ' legend' + divId
    //       )
    //       .style('fill', colors[i])
    //       .style('font-family', 'roboto')
    //       .style('font-weight', '500')
    //       .style('font-size', fontsize)
    //       .text(function (d) {
    //         return (
    //           d.attributeName +
    //           ' (' +
    //           (parseInt(totalCount) > 0
    //             ? numberWithCommas(parseFloat(d.attributeValue))
    //             : 0) +
    //           ')'
    //         );
    //       });
    //     const recTextsize = recText.node().getBBox();
    //     currentX += recTextsize.width + 20;
    //     if (currentX > width / 2) {
    //       currentX = -width / 2 + 20;
    //       legendline += 20;
    //       y = legendline;
    //       rect.attr('x', currentX).attr('y', y);
    //       currentX += size.width + 10;
    //       recText.attr('x', currentX).attr('y', y + 10);
    //       currentX += recTextsize.width + 20;
    //     }
    //     // console.log(size, recTextsize, d);
    //   });

    //  svgContainer.attr("height",svgSize.height+legendSize.height+20)
    // svgContainer.attr("width",svgSize.width*10);
  }
}

export { arcChartUtility };
